import React from "react";
import { Link, NavLink } from "react-router-dom";
import {
  ArrowLeftRight,
  ArrowUpRight,
  BarChart2,
  Gift,
  Inbox,
  LayoutGrid,
  RefreshCw,
  Settings,
  Target,
  Ticket,
  Trophy,
} from "lucide-react";
import { DASH_NAV_GROUPS } from "../../utils/dashboardHelpers";

const NAV_ICONS = {
  workspace: LayoutGrid,
  transactions: ArrowLeftRight,
  leaderboard: Trophy,
  markets: Target,
  joined: Ticket,
  requests: Inbox,
  picks: BarChart2,
  referrals: Gift,
};

const NavIcon = ({ id }) => {
  const Icon = NAV_ICONS[id] || LayoutGrid;
  return (
    <span className="dash-desk-nav-icon">
      <Icon size={14} />
    </span>
  );
};

const SectionNavItem = ({ item, active, onSelect }) => (
  <button
    type="button"
    className={`dash-desk-nav-item ${active ? "dash-desk-nav-item-active" : ""}`}
    onClick={() => onSelect(item.id)}
    aria-current={active ? "page" : undefined}
    title={item.hint}
  >
    <span className="dash-desk-nav-indicator" aria-hidden />
    <NavIcon id={item.id} />
    <span className="dash-desk-nav-copy">
      <strong>{item.label}</strong>
      {item.hint ? <em>{item.hint}</em> : null}
    </span>
  </button>
);

const LinkNavItem = ({ item }) => (
  <NavLink
    to={item.to}
    className={({ isActive }) =>
      `dash-desk-nav-item dash-desk-nav-link${isActive ? " dash-desk-nav-item-active" : ""}`
    }
    title={item.hint}
  >
    <span className="dash-desk-nav-indicator" aria-hidden />
    <NavIcon id={item.id} />
    <span className="dash-desk-nav-copy">
      <strong>{item.label}</strong>
      {item.hint ? <em>{item.hint}</em> : null}
    </span>
    <ArrowUpRight size={11} className="dash-desk-nav-exit" aria-hidden />
  </NavLink>
);

const DashboardRail = ({
  onRefresh,
  refreshing,
  activeSection,
  onSectionChange,
  displayName,
  userLevel,
  initial,
}) => (
  <aside className="dash-desk-rail" aria-label="Dashboard navigation">
    <div className="dash-desk-identity">
      <span className="dash-desk-avatar">{initial}</span>
      <div className="dash-desk-identity-copy">
        <h1>{displayName}</h1>
        {userLevel && <span className="dash-desk-level">{userLevel}</span>}
      </div>
    </div>

    <div className="dash-desk-nav-wrap">
      {DASH_NAV_GROUPS.map((group) => (
        <section
          key={group.id}
          className="dash-desk-nav-group"
          aria-label={group.label}
        >
          <p className="dash-desk-nav-group-label">{group.label}</p>
          <nav className="dash-desk-nav-group-items">
            {group.items.map((item) =>
              item.type === "section" ? (
                <SectionNavItem
                  key={item.id}
                  item={item}
                  active={activeSection === item.id}
                  onSelect={onSectionChange}
                />
              ) : (
                <LinkNavItem key={item.id} item={item} />
              )
            )}
          </nav>
        </section>
      ))}
    </div>

    <div className="dash-desk-rail-foot">
      <div className="dash-desk-rail-actions">
        <button
          type="button"
          className="dash-icon-btn"
          onClick={onRefresh}
          disabled={refreshing}
          aria-label="Refresh dashboard"
        >
          <RefreshCw size={13} className={refreshing ? "animate-spin" : ""} />
        </button>
        <Link to="/app/profile" className="dash-icon-btn" aria-label="Profile">
          <Settings size={13} />
        </Link>
      </div>
    </div>
  </aside>
);

export default DashboardRail;
